<template>
    <div class="site-left">
        <boxTitle :title="'运营指标'" :subtitle="'Operational indicators'"></boxTitle>
        <divBox class="all-round">
            <template>
                <div>
                    <boxList :list="allRoundData" :line="2"></boxList>
                </div>
            </template>
        </divBox>

        <div class="power-chart mt-30">
            <divBox :title="'当月换电里程'">
                <template>
                    <leftlicheng
                        v-if="lichengShow"
                        :id="'allLicheng'"
                        :licheng="allLicheng" />
                </template>
            </divBox>
            <divBox :title="'单车日均换电里程'">
                <template>
                    <leftlicheng
                        v-if="lichengShow"
                        :id="'dayLicheng'"
                        :licheng="dayLicheng" />
                </template>
            </divBox>
        </div>

        <divBox class="mt-50" style="height: 400px;" :title="'24小时换电次数分布&国网电价'">
            <template>
                <rightelectricityprice
                    v-if="rightelectricitypriceShow"
                    :id="'siterightelectricityprice'"
                    :xAxis="xAxis"
                    :series="series" />
            </template>
        </divBox>
    </div>
</template>

<script>
import boxTitle from '../../components/boxTitle.vue'
import divBox from '../../components/divBox.vue'
import boxList from '../../components/boxList.vue'

import leftlicheng from './left-licheng.vue'
import leftlichengday from './left-licheng-day.vue'
import rightelectricityprice from './right-electricity-price.vue'

import { dataInterface } from "@/api/dataInterfaceApi"
export default {
    components: {
        boxTitle,
        divBox,
        boxList,
        leftlicheng,
        leftlichengday,
        rightelectricityprice
    },
    inject: ['stationObj'],
    computed: {
        computedProperty() {
        return this.stationObj()
        }
    },
    watch: {
        computedProperty(val) {
            console.log("我是孙组件，我监听到了myData4改变", val)
            this.stationId = val.value
            this.lichengShow = false
            this.lichengShow = false
            this.rightelectricitypriceShow = false
            this.init()
        },
    },
    data() {
        return {
            allRoundData: [
                {
                    icon: 'car',
                    title: '累计换电车辆数',
                    value: '366',
                    unit: '辆',
                    color: '#43FFB9'
                },
                {
                    icon: 'power',
                    title: '备用电池数量',
                    value: '366',
                    unit: '块',
                    color: '#43FFB9'
                },
                {
                    icon: 'charts',
                    title: '循环次数占比',
                    value: '366',
                    unit: '%',
                    color: '#179DFF'
                },
                {
                    icon: 'clock',
                    title: '累计换电次数',
                    value: '366',
                    unit: '次',
                    color: '#179DFF'
                },
                {
                    icon: 'battery',
                    title: '累计消费电量',
                    value: '',
                    unit: '万度',
                    color: '#36FBFB'
                },
                {
                    icon: 'panel',
                    title: '累计换电里程',
                    value: '',
                    unit: '万公里',
                    color: '#36FBFB'
                }
            ],
            allLicheng: 0, // 累计里程
            dayLicheng: 0, // 当日里程
            lichengShow: false,
            rightelectricitypriceShow: false,
            xAxis: {},
            series: [],
            stationId: ''
        }
    },
    mounted() {
		// let val = this.stationObj()

		// this.stationId = val.value
		// this.stationName = val.name
		
		// this.init()
    },
    methods: {
        async init() {
            // 累计换电车辆数/换电次数/消费电量/换电里程
            let leijixinxi = await this.leijixinxi() || {}
            // 备用电池数
            let beiyondianchi = await this.beiyondianchi() || {}
            // 当月的次数负荷率，换电里程，单车日均换电里程
            let monthcishufuhelvlicheng = await this.monthcishufuhelvlicheng() || {}

            this.allRoundData[0].value = leijixinxi.totalChargeVehicleNum
            this.allRoundData[1].value = beiyondianchi.bfBatteryNum
            this.allRoundData[2].value = monthcishufuhelvlicheng.LoadRate
            this.allRoundData[3].value = leijixinxi.totalChargeNum
            this.allRoundData[4].value = leijixinxi.totalChargeElect
            this.allRoundData[5].value = leijixinxi.totalChargeMileage
            // 月总换电里程
            this.allLicheng = parseFloat(monthcishufuhelvlicheng.ChargeMileage, 10)
            // 单日换电里程
            this.dayLicheng = parseFloat(monthcishufuhelvlicheng.DayChargeMileage, 10)
            this.lichengShow = true

            // 24小时电价换电次数分布
            this.hourpricehuandiancishufenbu()
        },
        // 累计换电车辆数/换电次数/消费电量/换电里程
        leijixinxi() {
            return new Promise((resolve, reject) => {
                let params = {
                    "enCode": "TiDB-Energy-zhandian-leijixinxi",
                    "@station_id": this.stationId
                }
                dataInterface
                    .dataFaceApi(params)
                    .then((res) => {
                        console.log('leijixinxi============', res)
                        if(!res || !res.length || !res[0]) {
                            resolve({})
                        } else {
                            resolve(res[0])
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            })
        },
        // 备用电池数
        beiyondianchi() {
            return new Promise((resolve, reject) => {
                let params = {
                    "enCode": "TiDB-Energy-zhandian-beiyondianchi",
                    "@station_id": this.stationId
                }
                dataInterface
                    .dataFaceApi(params)
                    .then((res) => {
                        console.log('=========', res)
                        if(!res || !res.length || !res[0]) {
                            resolve({})
                        } else {
                            resolve(res[0])
                        }
                    })
                        .catch((err) => {
                        console.log(err);
                    })
            })
        },
        // 当月的次数负荷率，换电里程，单车日均换电里程
        monthcishufuhelvlicheng() {
            return new Promise((resolve, reject) => {
                let params = {
                    "enCode": "TiDB-Energy-zhandian-monthcishufuhelvlicheng",
                    "@station_id": this.stationId
                }
                dataInterface
                    .dataFaceApi(params)
                    .then((res) => {
                        console.log('=========', res)
                        if(!res || !res.length || !res[0]) {
                            resolve({})
                        } else {
                            resolve(res[0])
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            })
        },
        // 24小时电价换电次数分布
        hourpricehuandiancishufenbu() {
            let newDate = new Date()
            let month = newDate.getMonth() + 1
            let date = newDate.getDate() - 1
            let params = {
                "enCode": "TiDB-Energy-zhandian-24hourpricehuandiancishufenbu",
                "@station_id": this.stationId,
                "@curDate": `${newDate.getFullYear()}-${month < 10 ? '0' + month : month }-${date < 10 ? '0' + date : date}`
            }
            dataInterface
                .dataFaceApi(params)
                .then((res) => {
                    console.log('hourpricehuandiancishufenbu==============', res)
                    if(!res || !res.length || !res[0]) return {}
                    // this.stationInfo = res[0]
                    let xData = []
                    let price = []
                    let chargeNum = []
                    res.map((item, i) => {
                        xData.push(item.shiduan)
                        price.push(parseFloat(item.price || 0, 10))
                        chargeNum.push(parseFloat(item.chargeNum || 0, 10))
                    })
                    this.xAxis.data = xData
                    this.series = [chargeNum, price]
                    this.rightelectricitypriceShow = true
                })
                .catch((err) => {
                    console.log(err);
                })
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../comm.scss';
.site-left {
    margin-top: 20px;
    .all-round {
        padding: 15px 0;
        margin-top: 20px;
    }
    .power-chart {
        // margin-top: 6px;
        display: flex;
        width: 100%;
        > div {
            margin: 0 3px;
            &:first-child {
                margin-left: 0;
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }
}
</style>